module.exports = __webpack_public_path__ + "img/galerie_preview.c0491b15.jpg";